import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled from 'styled-components';

import {InteractionComponentProps} from '../../../../libs/shared/helpers/src/interaction/interactionHelpers';
import {BooleanInputProps} from '../../../../libs/shared/ui/src/components/booleanInputs/booleanInputTypes';
import {Toggle} from '../../../../libs/shared/ui/src/components/booleanInputs/toggle';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';
import {Disabled} from '../disabled';

/*
 * Props.
 */

interface QuickSettingsDropdownItemProps extends BooleanInputProps, InteractionComponentProps {
  title: ReactNode;
  description: ReactNode;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 12px;
`;

const StyledCommonDiv = styled.div`
  display: flex;
  align-items: center;
`;

const StyledTextDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-right: 12px;
`;

const StyledTitleDiv = styled.div`
  color: ${(p) => p.theme.greys.shade90};
  ${ellipsis()};
`;

const StyledDescription = styled.div`
  margin-top: 5px;

  color: ${(p) => p.theme.greys.shade60};
  font-size: ${fontSizes.small};
  ${ellipsis()};
`;

/*
 * Component.
 */

export const QuickSettingsDropdownItem: FC<PropsWithChildren<QuickSettingsDropdownItemProps>> = (props) => (
  <Disabled isDisabled={Boolean(props.isDisabled)}>
    <StyledWrapperDiv>
      <StyledCommonDiv>
        <StyledTextDiv>
          <StyledTitleDiv>{props.title}</StyledTitleDiv>
          <StyledDescription>{props.description}</StyledDescription>
        </StyledTextDiv>
        <Toggle {...props} size={VisualSizesEnum.SMALL} />
      </StyledCommonDiv>
      {props.children}
    </StyledWrapperDiv>
  </Disabled>
);
